import { get, post, BaseUrl, setAuthHeader, put } from './api'
import { authenticatePkce, popupAuthenticateMsal } from './../utils/oauthAuthentication'

export const getEditorFile = async (startParameter, errorHandlers, jwt = null) => {
  let axiosParams = null;
  if (jwt) {
    axiosParams = {
      headers: {
        authorization: 'Bearer ' + jwt
      }
    }
  }
  return await get(`api/WebEditor/${startParameter}`, window._env_?.REACT_APP_API_BASE_URL, {
    axiosParams: axiosParams,
    statusCodeHandlers: [
      ...errorHandlers,
    ]
  });
}

export const updateEditorFile = async (editorFile, startParameter,showProgressBar = false) => {
  return await put(`api/WebEditor/${startParameter}`, window._env_?.REACT_APP_API_BASE_URL, editorFile, { axiosParams: { showProgressBar: showProgressBar } });
}

export const previewPdf = async (startParameter) => {
  return await get(`api/WebEditor/${startParameter}/previewPdf`, window._env_?.REACT_APP_API_BASE_URL, { axiosParams: { responseType: 'arraybuffer' } });
}

export const previewHtml = async (startParameter) => {
  return await get(`api/WebEditor/${startParameter}/previewHtml`, window._env_?.REACT_APP_API_BASE_URL, { axiosParams: { responseType: 'arraybuffer' } });
}

export const getViewpointPdf = async (startParameter) => {
  return await get(`api/WebEditor/${startParameter}/viewpoint/Pdf`, window._env_?.REACT_APP_API_BASE_URL, { axiosParams: { responseType: 'arraybuffer' } });
}

export const getDynamoPdf = async (startParameter, jobId, docId) => {
  return await get(`api/WebEditor/${startParameter}/dynamo/Pdf/${jobId}/${docId}`, window._env_?.REACT_APP_API_BASE_URL, { axiosParams: { responseType: 'arraybuffer' } });
}

export const getAttachmentByStartParameter = async (startParameter) => {
  return await get(`api/WebEditor/${startParameter}/attachment`, window._env_?.REACT_APP_API_BASE_URL);
}

export const searchAttachmentFromLibrary = async (searchRequest, startParameter) => {
  return await post(`api/WebEditor/${startParameter}/attachment/library/search`, window._env_?.REACT_APP_API_BASE_URL, searchRequest);
}

export const previewAttachment = async (attachment,startParameter) => {
  return await post(`api/WebEditor/${startParameter}/attachment/library/preview`, window._env_?.REACT_APP_API_BASE_URL, attachment, { axiosParams: { responseType: 'arraybuffer' } });
}

export const getProcesses = async (startParameter) => {
  return await get(`api/WebEditor/${startParameter}/process`, window._env_?.REACT_APP_API_BASE_URL);
}

export const reloadSmartform = async (startParameter) => {
  return await post(`api/WebEditor/${startParameter}/reloadSmartform`, window._env_?.REACT_APP_API_BASE_URL);
}

export const getDistributionList = async (startParameter) => {
  return await get(`api/WebEditor/${startParameter}/distributionList`, window._env_?.REACT_APP_API_BASE_URL);
}